<template>
  <div>
    <slot name="header"></slot>
    <div class="template-two-hero-banner">
      <slot name="hero"></slot>
    </div>
    <div class="template-2-breadcrumb">
      <slot name="breadcrumb"></slot>
    </div>
    <div class="course-tile-list-v2-wrapper h-screen">
      <div
        class="template-two-container flex md:flex-row flex-col md:space-x-5"
      >
        <slot
          v-if="courseSettings.sidebar_position == 2"
          name="right-sidebar"
        ></slot>
        <slot name="course"></slot>
        <slot
          v-if="courseSettings.sidebar_position == 1"
          name="right-sidebar"
        ></slot>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>
<script>
export default {
  name: 'SubcategoryMarkup',
  data() {
    return {};
  },
  props: {
    courseSettings: {},
  },
};
</script>
<style lang="scss">
.template-2-breadcrumb {
  .membership-layout-container {
    max-width: 1130px;
    padding-bottom: 26px;
  }
  .active {
    //color : #EC745F;
    font-weight: 600;
  }
}
.template-two-hero-banner {
  .mb-10 {
    margin-bottom: 24px;
  }
  .pb-10 {
    padding-bottom: 1.5rem;
  }
}
.mobile-template {
  .template-2-breadcrumb {
    display: none;
  }
}
</style>